import unset from 'lodash/fp/unset'
import {formatValues} from 'employees/utils'
import {eachFormFiles} from 'employees/eachFormFiles'
import {isEmpty} from 'lodash'

export const toFormName = (name) => {
  const m = name.match(/employees_custom_values\.file\.(.*)/)
  if (m) {
    return `custom_fields.field_${m[1]}`
  }
  return name.replace(/^employee\./, '')
}

const sendFile = async ({file, dbName, authedApi, procedureStatusId, procedureTmpType, tmpFiles}) => {
  if (file && file instanceof File) {
    await authedApi.procedureStatuses.tmpFiles.createOrUpdate(procedureStatusId, file, procedureTmpType, dbName)
  } else if (!file) {
    const tmpFile = tmpFiles.find((tmpFile) => tmpFile.name === dbName)
    if (tmpFile) {
      await authedApi.procedureStatuses.tmpFiles.delete(procedureStatusId, tmpFile.id)
    }
  }
}

// 被扶養者情報に紐付くファイルを一時保存
export const saveDependentFiles = async ({authedApi, procedureStatusId, dependents, procedureTmpType, tmpFiles}) => {
  for (const file of eachFormFiles({dependents}, [])) {
    if (!file.dbName.startsWith('dependents.')) {
      continue
    }

    await sendFile({
      file: file.file,
      dbName: file.dbName,
      authedApi,
      procedureStatusId,
      procedureTmpType,
      tmpFiles,
    })
  }
}

export const saveWithFiles = async (authedApi, procedureStatusId, values, procedureTmpType, tmpFiles, customFields) => {
  let tmpData = unset('resumes', formatValues(values))
  for (const file of eachFormFiles(values, customFields, {ignorePermission: true})) {
    if (file.file !== null) {
      tmpData = unset(file.formName, tmpData)
    }
  }

  await authedApi.procedureStatuses.tmpData.createOrUpdate(procedureStatusId, tmpData, procedureTmpType, 'employee')

  for (const file of eachFormFiles(values, customFields)) {
    await sendFile({file: file.file, dbName: file.dbName, authedApi, procedureStatusId, procedureTmpType, tmpFiles})
  }
}

export const getR150ReportValues = (tmpData, dependent, dependentIndex, dependents, socialInsuranceDependents) => {
  const reportParamsSets = JSON.parse(tmpData['report_params_sets']?.data || '{}')

  if (!isEmpty(reportParamsSets)) {
    // 家族対応リリース後に作成された入社手続きはreport_params_setsを使用する
    return reportParamsSets[dependent._id]?.r150_param_set
  } else {
    // 家族対応リリース前に作成された入社手続きはdependent_info_${dependentIndex}を使用する
    if (dependents.length === socialInsuranceDependents.length) {
      // 入社の手続きに紐づく被扶養者と社保扶養対象の被扶養者が同じ場合はdependentIndexを使用
      return JSON.parse(tmpData[`dependent_info_${dependentIndex}`]?.data || '{}')
    } else {
      // 入社の手続きに紐づく被扶養者と社保扶養対象の被扶養者が違う場合(家族対応リリース後に修正依頼をして社保扶養を変更したケース)は_idからindexを取得
      const index = dependents.findIndex((item) => item._id === dependent._id)
      return JSON.parse(tmpData[`dependent_info_${index}`]?.data || '{}')
    }
  }
}
